import PropTypes from 'prop-types';
import React, { useState } from 'react';
import ImageWrapper from '../../../ImageWrapper';
import { IMAGE_BIG_SIZE, IMAGE_SMALL_SIZE } from '../../../../const/responsive';

export default function ImageSlider({ images }) {
  if (images.length === 0) {
    return null;
  }

  if (!images[0].url) {
    return null;
  }

  const [selectedImg, setSelectedImg] = useState(images[0]);

  return (
    <>
      <div className="mt-md-4 ratio ratio-1x1">
        <ImageWrapper
          className="rounded with-placeholder object-fit-cover"
          width={IMAGE_BIG_SIZE}
          height={IMAGE_BIG_SIZE}
          src={selectedImg.url}
          alt={selectedImg.alt}
          priority
        />
      </div>
      {images.length > 1 && (
        <div className="overflow-auto text-nowrap">
          {images.map((image) => (
            <div className="m-2 ratio ratio-1x1" key={image.id}>
              <ImageWrapper
                onClick={() => setSelectedImg(image)}
                className="m-2 rounded object-fit-cover"
                width={IMAGE_SMALL_SIZE}
                height={IMAGE_SMALL_SIZE}
                src={image.url}
                alt={image.alt}
              />
            </div>
          ))}
        </div>
      )}
    </>
  );
}

ImageSlider.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({
    image_id: PropTypes.number,
    url: PropTypes.string,
    alt: PropTypes.string,
  })).isRequired,
};
